/** utilsの`removeCookie`で削除できる`COOKIE` */
export const COOKIE = {
  ADULT_LINK_DISABLE: {
    KEY: "adult_link_disable",
    VALUE: "true",
  },
  NOTIFIED_PRICE_DOWN: {
    KEY: "notified_price_down",
    VALUE: "true",
  },
  PRICE_DOWN_NOTICE_LENGTH: {
    KEY: "price_down_notice_length",
    VALUE: "",
  },
  VISITOR_ID: {
    KEY: "rieSh3Ee_ga",
    VALUE: "",
  },
  IS_FIRST_VISITED_SEASON_IDS: {
    KEY: "is_first_visited_product_ids",
    VALUE: "",
  },
  HAS_CONTENT_ONLY: {
    KEY: "has_content_only",
    VALUE: "true",
  },
  IS_OPEN_RECOMMENDATION_MODAL_FLAG: {
    KEY: "is_recommendation_modal_open",
  },
} as const;

/** utilsの`removeCookie`で削除できない`COOKIE` */
export const NOT_REMOVE_COOKIE = {
  /** ログインしているかどうかの判定を行うための`COOKIE` */
  LOGIN_SESSION_ID: {
    KEY: "login_session_id",
    VALUE: "",
  },
  /** has_althash がある場合に自動ログイン判定を行うための`COOKIE` */
  HAS_ALT_HASH: {
    KEY: "has_althash",
    VALUE: "",
  },
} as const;

export type CookieType = keyof typeof COOKIE;

type ValueOf<T extends Record<string, unknown>> = T[keyof T];
export type CookieKeyType = ValueOf<typeof COOKIE>["KEY"] | ValueOf<typeof NOT_REMOVE_COOKIE>["KEY"];
